import { render, staticRenderFns } from "./MyLists.vue?vue&type=template&id=ebb3bf16"
import script from "./MyLists.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyLists.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports